(function () {
    $(function () {
        $(document).on('is:errorModal', function (e, data = {}) {
            const title = data.title || "Произошла ошибка!";
            const text = data.text || ((data.text === false) ? "" : "Необходимо попробовать снова. Приносим извинения за неудобства.");
            const btnText = data.btnText;
            const link = data.link;
            const linkText = data.linkText;
            const userClass = data.userClass || "";
            
            let html = '';
            html += 
                `<div class="modal-warning js-warning ${userClass}" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-content__inner js-modal-content-inner">
                            <div class="modal-warning-content">
                                <div class="warning-title js-warning__title">${title}</div>`;
    
            if (text) {
                html += `<div class="warning-text js-warning__text">${text}</div>`;
            }
            if (btnText) {
                html += `<div class="warning-action"><button class="b-btn _red js-warning__btn">${btnText}</button></div>`;
            }
            if (link) {
                html += `<div class="warning-action"><a href="${link}" class="b-btn _red">${(linkText) ? linkText : 'Перейти'}</a></div>`;
            }
            
            html += `</div></div></div></div>`;
    
    
            $.fancybox.open({
                // src  : '#modalWarning',
                src  : html,
                type : 'inline',
                opts : {
                    closeExisting: true,
                    smallBtn: true,
            
                    touch: false,
            
                    baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-stage"></div>' +
                    '</div>',
            
                    buttons: [
                        "close"
                    ],
            
                    btnTpl: {
                        smallBtn:
                        '<button data-fancybox-close class="fancybox-modal-close-custom" title="{{CLOSE}}">' +
                        '<svg fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 0.707109 -0.707104 0.707109 1.4541 0.000244141)" fill="#949599" stroke="#949599" stroke-width="0.3"/>\n' +
                        '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 -0.707109 0.707104 0.707109 0.000976562 14.5454)" fill="#949599" stroke="#949599" stroke-width="0.3"/>\n' +
                        '</svg>' +
                        '</button>'
                    },
            
                    baseClass: "fancybox-modal-custom",
            
                    clickOutside: "close",
            
                    afterShow: function( instance, slide ) {
                        const $wrapper = slide.$slide.find(".js-modal-content-inner");
                
                        if ($wrapper.length > 0) {
                            new SimpleBar($wrapper[0]);
                        }
                
                        slide.$slide.find(".js-warning__btn").on("click", function (e) {
                            e.preventDefault();
                            slide.$slide.find(".js-warning").trigger('is:clicked');
                            instance.close();
                        });
                    },
            
                    lang: "ru",
                    i18n: {
                        en: {
                            CLOSE: "Close",
                            NEXT: "Next",
                            PREV: "Previous",
                            ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                            PLAY_START: "Start slideshow",
                            PLAY_STOP: "Pause slideshow",
                            FULL_SCREEN: "Full screen",
                            THUMBS: "Thumbnails",
                            DOWNLOAD: "Download",
                            SHARE: "Share",
                            ZOOM: "Zoom"
                        },
                        ru: {
                            CLOSE: "Закрыть",
                            NEXT: "След.",
                            PREV: "Пред.",
                            ERROR: "Невозможно загрузить контент. <br/> Пожалуйста, попробуйте позднее.",
                            PLAY_START: "Начать слайдшоу",
                            PLAY_STOP: "Поставить на паузу",
                            FULL_SCREEN: "Во весь экран",
                            THUMBS: "Превью",
                            DOWNLOAD: "Скачать",
                            SHARE: "Поделиться",
                            ZOOM: "Увеличить"
                        }
                    }
                }
            });
        });
    })
}());
